import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QuestionModel } from '../models/app.models';

/**
 * CRUD nad `/api/questions` (viz QuestionsController). Vzor podle TodoService —
 * jedna metoda na jeden endpoint, bez lokálního cache/state (to drží
 * AssistantBadgeService pro odznak a QuestionListComponent pro seznam).
 */
@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  private apiUrl = '/api/questions';

  constructor(private http: HttpClient) {
  }

  /** Vrací jen otevřené otázky (BE filtr, viz QuestionsController.Get). */
  getOpen(): Observable<QuestionModel[]> {
    return this.http.get<QuestionModel[]>(this.apiUrl);
  }

  /** Lehký COUNT pro odznak (viz AssistantBadgeService) — nenačítá celý seznam. */
  getOpenCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/open-count`);
  }

  answer(id: number, value: string): Observable<QuestionModel> {
    return this.http.post<QuestionModel>(`${this.apiUrl}/${id}/answer`, { value });
  }

  dismiss(id: number): Observable<QuestionModel> {
    return this.http.post<QuestionModel>(`${this.apiUrl}/${id}/dismiss`, {});
  }
}
